import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from '../../utils/httpRequest';
import '../../css/Select.css';
import ModalDiv from "../../ModalDiv";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
const apiUrl = Config.apiUrl;

const SupplierSelect = (props) => {
    const {onItemClick, onClose} = props;
    const [suppliers, setSuppliers] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);

    async function makeQuery(query) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/suppliers/query=' + (query && query !== '' ? query : '');
            const response = await makeRequest(url, 'GET');
            setSuppliers(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []);

    const handleInputChange = async (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            await makeQuery(string);
        }
        setQueryString(string);
    };


    const handleQuery = async (e) => {
        await makeQuery(queryString);
    };

    return (
        <ModalDiv closeModal={onClose} style_={{width: '500px'}}>
            <div className="header-label">Consulta de Fornecedores</div>
            <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
            <table style={{width: '495px', height: '480px'}}>

                <colgroup>
                    <col style={{width: '50px'}}/>
                    <col style={{width: '500px'}}/>
                </colgroup>

                <tr>
                    <th>
                        Código
                    </th>
                    <th>
                        Nome
                    </th>
                </tr>

                {suppliers.map((supplier, index) => (

                    <tr key={index}
                        className="select-list-item"
                        onClick={() => {
                            onItemClick(supplier.id);
                        }}
                        onMouseEnter={() => {
                            // Handle hover effect (change background color)
                        }}
                        onMouseLeave={() => {
                            // Handle hover effect (restore background color)
                        }}>
                        <td>
                            <div>
                                {supplier.code}
                            </div>
                        </td>
                        <td>
                            <div>
                                {supplier.name}
                            </div>
                        </td>
                    </tr>

                ))}
                {suppliers.length === 0 && <div className="select-list-empty">Nenhum item encontrado.</div>}


            </table>
        </ModalDiv>
    );
};

export default SupplierSelect;
